export default __webpack_public_path__ + "static/media/ga-003.2f4a8d42.jpg";